module.exports = __webpack_public_path__ + "illinois-7a5970b169b5a9aef5bbbc0736f63bf0.svg";